import useAnamNudgytAgentCoreClient from '../../hooks/useAnamNudgytAgentCoreClient';

function AnamNudgytAgentCoreClient({
  aiResponsePlaybackActiveRef,
  isVideoStreamReady,
  handleSendAudioChunk,
  handleEndAudioSequence
}) {
  useAnamNudgytAgentCoreClient({
    aiResponsePlaybackActiveRef,
    isVideoStreamReady,
    handleSendAudioChunk,
    handleEndAudioSequence
  });

  return null;
}

export default AnamNudgytAgentCoreClient;
